module.exports = __webpack_public_path__ + "img/structural_icon_aedecp.080c0830.svg";